(function () {
  var root = document.querySelector(".cpc-produto");
  if (!root) return;
  var dataNode = root.querySelector("[data-cpc-variants]");
  if (!dataNode) return;
  var variants = JSON.parse(dataNode.textContent);
  var hidden = root.querySelector("[data-cpc-variant]");
  var amount = root.querySelector("[data-cpc-amount]");
  var compare = root.querySelector("[data-cpc-compare]");
  var deal = root.querySelector("[data-cpc-detail-deal]");
  var dealPercent = root.querySelector("[data-cpc-detail-percent]");
  var compareWrap = root.querySelector("[data-cpc-detail-compare-wrap]");
  var baseAmount = root.querySelector("[data-cpc-base-amount]");
  var saving = root.querySelector("[data-cpc-detail-saving]");
  var savingValue = root.querySelector("[data-cpc-detail-saving-value]");
  var photo = root.querySelector("[data-cpc-photo]");
  var installment = root.querySelector("[data-cpc-installment]");
  var buy = root.querySelector("[data-cpc-buy]");
  var stockIn = root.querySelector("[data-cpc-stock-in]");
  var stockOut = root.querySelector("[data-cpc-stock-out]");

  function money(cents) {
    return (cents / 100).toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
  }

  function pix(cents) {
    return cents - Math.floor(cents * 5 / 100);
  }

  function installmentText(cents) {
    var count = Math.max(1, Math.min(12, Math.floor(cents / 650)));
    return count + "x de " + money(Math.floor(cents / count));
  }

  function selected() {
    var choice = {};
    root.querySelectorAll("[data-cpc-option][aria-pressed='true']").forEach(function (button) {
      choice[button.getAttribute("data-cpc-option")] = button.getAttribute("data-cpc-value");
    });
    return choice;
  }

  function matches(variant, choice) {
    return ["1", "2", "3"].every(function (position) {
      if (!choice[position]) return true;
      return variant["option" + position] === choice[position];
    });
  }

  function pick(list) {
    var available = list.filter(function (variant) { return variant.available; });
    var pool = available.length ? available : list;
    var common = pool.find(function (variant) {
      return [variant.option1, variant.option2, variant.option3].join(" ").indexOf("24") !== -1;
    });
    return common || pool[0];
  }

  function paintOptions() {
    var choice = selected();
    root.querySelectorAll("[data-cpc-option]").forEach(function (button) {
      var trial = {};
      Object.keys(choice).forEach(function (key) { trial[key] = choice[key]; });
      trial[button.getAttribute("data-cpc-option")] = button.getAttribute("data-cpc-value");
      var list = variants.filter(function (variant) { return matches(variant, trial); });
      var ok = list.some(function (variant) { return variant.available; });
      button.classList.toggle("is-unavailable", list.length > 0 && !ok);
    });
  }

  function apply(variant) {
    if (!variant) return;
    hidden.value = variant.id;
    root.dispatchEvent(new CustomEvent('cpc:variant-changed', { bubbles: true, detail: variant }));
    amount.textContent = money(pix(variant.price));
    var sale = variant.compare > variant.price;
    if (baseAmount) baseAmount.textContent = money(variant.price);
    if (deal && dealPercent) {
      var percent = sale ? Math.floor((variant.compare - variant.price) * 100 / variant.compare) : 0;
      var showDeal = percent >= 5;
      deal.hidden = !showDeal;
      dealPercent.textContent = showDeal ? percent + '% OFF' : '';
    }
    if (compareWrap) compareWrap.hidden = !sale;
    if (saving && savingValue) {
      saving.hidden = !sale;
      savingValue.textContent = sale ? money(variant.compare - variant.price) : '';
    }
    if (installment) installment.textContent = installmentText(variant.price);
    if (variant.compare > variant.price) {
      compare.hidden = false;
      compare.textContent = money(variant.compare);
    } else {
      compare.hidden = true;
    }
    if (photo && variant.image) {
      photo.src = variant.image;
      photo.setAttribute("data-cpc-zoom", variant.image);
    }
    buy.disabled = !variant.available;
    buy.textContent = variant.available ? "Comprar" : "Esgotado";
    if (stockIn) stockIn.hidden = !variant.available;
    if (stockOut) stockOut.hidden = !!variant.available;
    var cor = root.querySelector("[data-cpc-cor]");
    var corBotao = root.querySelector("[data-cpc-color][aria-pressed='true']");
    if (cor && corBotao) cor.textContent = corBotao.textContent.trim();
    paintOptions();
  }

  function showThumb(thumb) {
    if (!thumb || !photo) return;
    photo.src = thumb.getAttribute("data-src");
    photo.setAttribute("data-cpc-zoom", thumb.getAttribute("data-zoom") || thumb.getAttribute("data-src"));
    root.querySelectorAll("[data-cpc-thumb]").forEach(function (item) {
      item.setAttribute("aria-pressed", item === thumb ? "true" : "false");
    });
  }

  function showSlide(img) {
    if (!img || !photo) return;
    var next = img.currentSrc || img.getAttribute("src") || "";
    next = next.split(";")[0].replace(/&amp;/g, "&");
    if (!next) return;
    if (/[?&]width=\d+/.test(next)) next = next.replace(/([?&])width=\d+/, "$1width=1200");
    else next += (next.indexOf("?") >= 0 ? "&" : "?") + "width=1200";
    photo.src = next;
    photo.setAttribute("data-cpc-zoom", next);
  }

  root.addEventListener("click", function (event) {
    var thumb = event.target.closest("[data-cpc-thumb]");
    if (thumb && photo) {
      showThumb(thumb);
      return;
    }
    var button = event.target.closest("[data-cpc-option]");
    if (!button) return;
    var position = button.getAttribute("data-cpc-option");
    root.querySelectorAll('[data-cpc-option="' + position + '"]').forEach(function (item) {
      item.setAttribute("aria-pressed", item === button ? "true" : "false");
    });
    var choice = selected();
    apply(pick(variants.filter(function (variant) { return matches(variant, choice); })));
  });

  root.addEventListener("mouseover", function (event) {
    if (!window.matchMedia("(hover: hover) and (pointer: fine)").matches) return;
    var thumb = event.target.closest("[data-cpc-thumb]");
    if (thumb) {
      showThumb(thumb);
      return;
    }
    var slide = event.target.closest(".pf-slider img, .pf-slide img");
    if (slide && root.contains(slide)) showSlide(slide);
  });

  var current = variants.find(function (variant) { return String(variant.id) === String(hidden.value); });
  if (current) apply(current);
  else paintOptions();

  var frame = root.querySelector(".cpc-produto__frame");
  var lens = root.querySelector(".cpc-produto__lens");
  var pane = root.querySelector(".cpc-produto__zoom");
  if (frame && photo && lens && pane) {
    frame.addEventListener("mousemove", function (event) {
      var rect = frame.getBoundingClientRect();
      if (!rect.width || !rect.height) return;
      frame.classList.add("is-zooming");
      var paneRect = pane.getBoundingClientRect();
      var lw = Math.min(150, rect.width * 0.38);
      var lh = Math.min(150, rect.height * 0.38);
      var x = event.clientX - rect.left;
      var y = event.clientY - rect.top;
      var lx = Math.max(0, Math.min(x - lw / 2, rect.width - lw));
      var ly = Math.max(0, Math.min(y - lh / 2, rect.height - lh));
      var scaleX = (paneRect.width || rect.width) / lw;
      var scaleY = (paneRect.height || rect.height) / lh;
      var src = photo.getAttribute("data-cpc-zoom") || photo.currentSrc || photo.src;
      lens.style.width = lw + "px";
      lens.style.height = lh + "px";
      lens.style.left = lx + "px";
      lens.style.top = ly + "px";
      pane.style.backgroundImage = 'url("' + src.replace(/"/g, "") + '")';
      pane.style.backgroundSize = (rect.width * scaleX) + "px " + (rect.height * scaleY) + "px";
      pane.style.backgroundPosition = (-lx * scaleX) + "px " + (-ly * scaleY) + "px";
    });
    frame.addEventListener("mouseleave", function () {
      frame.classList.remove("is-zooming");
    });
  }
})();
